import React from 'react';
import { animated, config, useTransition } from 'react-spring';
import styled from 'styled-components';
import { useActiveContext } from '../Context/ActiveContext';
import MobileActivitySlide from '../Slides/MobileActivitySlide';
const Container = styled.div `
  width: 100%;
  border-radius: 8px;
  z-index: 9;
  position: ${({ relativePositioning }) => relativePositioning ? 'relative' : 'initial'};

  .slide-transition {
    max-height: fit-content;
    background: #fff;
    width: 100%;
    border-radius: 8px;
  }

  margin-top: ${({ theme, isMapHidden }) => isMapHidden ? -theme.distances.mobileMapHeight : 0}px;
`;
const MobileSlideController = ({ scrollToTop, showProductJourneyCards, }) => {
    const transitions = useTransition('mobile_slides', {
        from: { transform: 'translateX(90px)' },
        enter: { transform: 'translateX(0)' },
        config: config.stiff,
    });
    const { steps, activeStepActivity: activeActivity } = useActiveContext();
    const slideProps = {
        steps,
        mobile: true,
        scrollToTop,
    };
    return (React.createElement(Container, null, transitions((styles, item, _, i) => {
        return (React.createElement(animated.div, { key: i, style: styles, className: "slide-transition" },
            React.createElement(MobileActivitySlide, Object.assign({}, slideProps, { showProductJourneyCards: showProductJourneyCards, activity: activeActivity }))));
    })));
};
export default MobileSlideController;
